import MainPage from 'navigation/pages/MainPage';
import modulesMap from 'core/modulesMap';
import { bindMethod } from 'helpers/bind';
import store from 'store';
import HomeBlocks from './partials/HomeBlocks';
class Home extends MainPage {
    getModulesMap() {
        return {
            ...modulesMap,
            homeBlocks: ['.home__blocks', HomeBlocks]
        };
    }
    async initialized() {
        super.initialized();
    }
    getModuleParams(el, componentConstructor) {
        {
            return {
                parent: this,
                pageManager: this.pageManager
            };
        }
    }
    bindEvents(add) {
        super.bindEvents(add);
        const method = bindMethod(add);
        if (this.refs.homeSearch)
            this.refs.homeSearch[method]('click', this.onHomeSearchClicked);
    }
    onHomeSearchClicked = () => {
        store.drawer.set('search');
    };
}
export default Home;
